import React from 'react';
import { QuickPickWrapper } from './styled';
import Headline from 'ui/Headline';
import Text from 'ui/Text';
import Button from 'ui/controls/Button';
import FlexWrapper from 'ui/FlexWrapper';
import Wrapper from 'ui/Wrapper';
import moment from 'moment';
import { connect } from 'react-redux';
import { showModal } from 'common/actions/uiActions';
import startsInIcon from 'images/icons/starts_in_white.png';
import amountIcon from 'images/icons/starts_in_white.png';
import Countdown from 'features/Countdown';
import bgGS75 from 'images/atg-style/GS75.png';
import bgV45 from 'images/atg-style/V4-5.png';
import bgV64 from 'images/atg-style/V64.png';
import bgV65 from 'images/atg-style/V65.png';
import bgV75 from 'images/atg-style/V75.png';
import bgV86 from 'images/atg-style/V86.png';
import lGS75 from 'images/atg-style/GS75-label.png';
import lV4 from 'images/atg-style/V4-label.png';
import lV5 from 'images/atg-style/V5-label.png';
import lV64 from 'images/atg-style/V64-label.png';
import lV65 from 'images/atg-style/V65-label.png';
import lV75 from 'images/atg-style/V75-label.png';
import lV86 from 'images/atg-style/V86-label.png';
import { IS_TERMINAL } from 'utils/platforms';
import NotificationConductor from 'common/conductors/NotificationConductor';
import { resetDerbyLynBet } from 'features/BetSlipState/actions';
import UserSession from 'common/adapters/UserSession';
import get from 'lodash/get';
import { terminalLogin } from 'common/actions/authActions';

import getTexts from 'utils/localization';
const t = getTexts();

const BACKGROUNDS = {
    GS75: bgGS75,
    V4: bgV45,
    V5: bgV45,
    V64: bgV64,
    V65: bgV65,
    V75: bgV75,
    V86: bgV86,
};
const LABELS = {
    GS75: lGS75,
    V4: lV4,
    V5: lV5,
    V64: lV64,
    V65: lV65,
    V75: lV75,
    V86: lV86,
};

class QuickPickCard extends React.Component {
    componentDidMount() {
        const { item, derbyLynBet } = this.props;

        if (
            derbyLynBet &&
            item.product.id === derbyLynBet.product.id &&
            item.track.code === derbyLynBet.trackCode &&
            moment(item.date).format('YYYY-MM-DD') === derbyLynBet.date
        ) {
            this.props.showQuickPickAmountModal(this.props);
            this.props.resetDerbyLynBet();
        }
    }

    onClickProced = () => {
        const {
            shopConfig,
            auth,
            showQuickPickAmountModal,
            showLoginModal,
        } = this.props;

        const playAndPayAllowed = get(
                shopConfig,
                'data.playAndPayAllowed',
                false
            ),
            playAndPayWorkflowAllowed =
                playAndPayAllowed &&
                IS_TERMINAL &&
                UserSession.isLowAmount(auth) &&
                !UserSession.isManagerEntrance();

        if (auth.user || playAndPayWorkflowAllowed) {
            showQuickPickAmountModal(this.props);
        } else {
            if (IS_TERMINAL) {
                let message = t.Terminal.notifications.startSession;
                /** restoring lost user on ManagerPC  */
                if (
                    // UserSession.isManagerEntrance() &&
                    UserSession.getSessionId()
                ) {
                    console.log('TS. Restoring from BetSlip');

                    message = t.Terminal.notifications.startManagerSession;
                    this.props.terminalLogin(UserSession);
                }

                NotificationConductor.info(message);
            } else {
                showLoginModal();
            }
        }
    };

    getCardInfoView = (smallMode, product, track, amount, date) => {
        if (!smallMode) {
            return (
                <div>
                    <FlexWrapper
                        height="17px"
                        padding="5px 30px 0px"
                        direction="row"
                        width="auto"
                        align="space-between"
                    >
                        <Text
                            align="left"
                            width="150px"
                            padding="0px"
                            white
                            block
                        >
                            {t.DerbyFlash.currentPool}:
                        </Text>
                        <Text
                            align="left"
                            width="110px"
                            padding="0px"
                            white
                            block
                        >
                            {t.DerbyFlash.restarts}:
                        </Text>
                    </FlexWrapper>

                    <FlexWrapper
                        height="17px"
                        padding="0px 30px"
                        direction="row"
                        width="auto"
                        align="space-between"
                    >
                        <Text
                            width="150px"
                            padding="0px"
                            white
                            block
                            bold="700"
                            size="18"
                            uppercase
                        >
                            {amount} -
                        </Text>
                        <Text
                            width="110px"
                            padding="0px"
                            white
                            block
                            bold="700"
                            size="18"
                            uppercase
                        >
                            {moment(date).fromNow()}
                        </Text>
                    </FlexWrapper>
                    <Wrapper height="30px" padding="0px">
                        <Button
                            white
                            block
                            size="x1"
                            textsize="12px"
                            bold
                            shadow="10"
                            width="140px"
                            margin="15px auto"
                            uppercase
                            rounded={30}
                            onClick={this.onClickProced}
                        >
                            {t.DerbyFlash.bayFlashGame.toUpperCase()}
                        </Button>
                    </Wrapper>
                </div>
            );
        } else {
            return (
                <div>
                    <Wrapper
                        height="20px"
                        padding="0px"
                        direction="row"
                        align="space-evenly"
                    >
                        <Text
                            padding="0px 15px"
                            white
                            block
                            size="x4"
                            uppercase
                        >
                            <img
                                alt="icon"
                                src={amountIcon}
                                width="14px"
                                style={{ verticalAlign: 'middle' }}
                            />{' '}
                            {amount} -
                        </Text>
                        <Text
                            padding="0px 15px"
                            white
                            block
                            size="x4"
                            uppercase
                        >
                            <img
                                alt="icon"
                                src={startsInIcon}
                                width="14px"
                                style={{ verticalAlign: 'middle' }}
                            />{' '}
                            {moment(date).fromNow()}
                        </Text>
                    </Wrapper>
                    <Wrapper height="30px" padding="0px">
                        <Button
                            white
                            block
                            size="x1"
                            shadow="10"
                            width="100px"
                            margin="27px auto 0px"
                            onClick={this.onClickProced}
                            uppercase
                            rounded={30}
                        >
                            {t.DerbyFlash.bayFlashGame.toUpperCase()}
                        </Button>
                    </Wrapper>
                </div>
            );
        }
    };

    getCardView = (smallMode, product, track, amount, date) => {
        return (
            <QuickPickWrapper small={this.props.small} bg={product.color}>
                <Headline
                    margin={smallMode ? '15px 14px 0px' : '10px 30px 0px'}
                    padding="10px 0px 0px"
                    height={smallMode ? '22px' : '30px'}
                    short
                    white
                    size={smallMode ? 'x1' : 'x3'}
                >
                    {product.name} - {track.name}
                </Headline>

                {this.getCardInfoView(smallMode, product, track, amount, date)}
            </QuickPickWrapper>
        );
    };

    getDesktopCardView = (product, track, amount, date) => {
        return (
            <QuickPickWrapper
                bg={`url('${BACKGROUNDS[product.id]}')`}
                style={{
                    height: '132px',
                }}
            >
                <Wrapper align="center" padding="20px 10px 10px">
                    <img
                        src={LABELS[product.id]}
                        height="50px"
                        alt={product.id}
                    />
                </Wrapper>

                <Text
                    padding="5px 10px 0px"
                    white
                    align="center"
                    block
                    size="x4"
                    style={{
                        fontWeight: 700,
                        textTransform: 'uppercase',
                    }}
                >
                    <Countdown
                        time={date}
                        timeUTC={date}
                        alwaysDisplayStartTime={true}
                        withDay={true}
                        limit={3600}
                        serverTime={this.props.serverTime}
                    />
                    , {track?.name}
                </Text>

                <Wrapper height="30px" padding="0px">
                    <Button
                        accent
                        block
                        size="x1"
                        textsize="14px"
                        padding="10px"
                        bold
                        shadow="10"
                        width="140px"
                        margin="12px auto"
                        uppercase
                        rounded={30}
                        onClick={this.onClickProced}
                    >
                        {t.DerbyFlash.bayFlashGame.toUpperCase()}
                    </Button>
                </Wrapper>
            </QuickPickWrapper>
        );
    };

    render() {
        const { product, track, date } = this.props.item;
        const amount = this.props.item?.jackpot?.sum
            ? this.props.item?.jackpot?.sum
            : this.props.item?.turnover?.sum;

        if (!this.props.small) {
            //return this.getCardView(false, product, track, amount, date);
            return this.getDesktopCardView(product, track, amount, date);
        } else {
            return (
                <Wrapper
                    width={
                        this.props.small > 0
                            ? 100 / this.props.small + '%'
                            : '50%'
                    }
                    padding="0px"
                    margin="0px"
                    style={{ float: 'left' }}
                >
                    {this.getDesktopCardView(product, track, amount, date)}
                </Wrapper>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    serverTime: state.AISDataProvider.serverTime,
    derbyLynBet: state.BetSlip.derbyLynBet,
    shopConfig: state.ShopConfig,
});

const mapDispatchToProps = (dispatch) => {
    return {
        showLoginModal: () => {
            dispatch(showModal('LOGIN'));
        },
        showQuickPickAmountModal: (data) => {
            dispatch(showModal('QUICK_PICK_AMOUNT', -896, data));
        },
        resetDerbyLynBet: () => {
            dispatch(resetDerbyLynBet());
        },
        terminalLogin: (sessionId) => {
            dispatch(terminalLogin(sessionId));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuickPickCard);
